/* eslint-disable */
import * as React from "react";
import { ContextExample } from "../ContextExample";

export const ComponentExample: React.FC<{ context: ContextExample }> = (props) => {
  const [state, setState] = React.useState(props.context);
  const [value, setValue] = React.useState<string>("");
  React.useEffect(() => {
    const subsrc = state.value.subscribe(val => {
      setValue(val);
    });
    return () => {
      subsrc.unsubscribe();
    }
  }, [state]);
  return <div> Parameter value {value} </div>;
};
